import { Box, Checkbox } from '@mui/material'

export function CheckboxUI({
  checked,
  handlePointerDown,
  size = 20,
  disabled = false,
}: {
  checked: boolean
  handlePointerDown: (e: React.PointerEvent<HTMLButtonElement>) => void
  size?: number
  disabled?: boolean
}) {
  return (
    <Checkbox
      checked={checked}
      checkedIcon={
        disabled ? (
          <Box
            sx={{
              width: size,
              height: size,
              borderRadius: '6px',
              bgcolor: '#F9FAFB',
              padding: '3px',
              border: '1px solid #D0D5DD',
            }}
          >
            <CheckBoxDisabled />
          </Box>
        ) : (
          <Box
            sx={{
              width: size,
              height: size,
              borderRadius: '6px',
              bgcolor: '#DD2590',
              padding: '3px',
            }}
          >
            <CheckIcon size={size - 5} />
          </Box>
        )
      }
      color="secondary"
      disabled={disabled}
      icon={
        disabled ? (
          <Box
            sx={{
              width: size,
              height: size,
              borderRadius: '6px',
              bgcolor: '#F9FAFB',
              padding: '3px',
              border: '1px solid #D0D5DD',
            }}
          >
            <CheckBoxDisabled />
          </Box>
        ) : (
          <Box
            sx={{
              width: size,
              height: size,
              borderRadius: '6px',
              border: '1px solid #D0D5DD',
            }}
          />
        )
      }
      inputProps={{
        'aria-label': 'Multiple Choice Option Check',
      }}
      size="small"
      sx={{ padding: '0px' }}
      onPointerDown={e => {
        e.stopPropagation()
        handlePointerDown(e)
      }}
    />
  )
}

function CheckIcon({ size }: { size: number }) {
  return (
    <svg fill="none" height={size} viewBox="0 0 15 15" width={size} xmlns="http://www.w3.org/2000/svg">
      <path
        d="m12.17 4.172-6.417 6.417-2.917-2.917"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function CheckBoxDisabled() {
  return (
    <Box>
      <svg fill="none" height="10" viewBox="0 0 12 12" width="10" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.5 6H9.5" stroke="#D0D5DD" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
      </svg>
    </Box>
  )
}
